export default __webpack_public_path__ + "dist/media/Delete-red.956c6536.svg";